import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import styles from "@/styles/Video.module.scss";
import { useCallback } from "react";

export default function DvrLive({ state }) {
  const handleLiveEdge = useCallback(() => {
    state.updateResumePoint(-1);
  }, []);
  const handleStart = useCallback(() => {
    state.updateResumePoint(0.1);
  }, []);

  return (
    <div className={styles.dvrlive}>
      <div className={styles.buttons}>
        <ButtonMultiClick fillColor medium onClick={handleLiveEdge}>
          ライブ位置から再生
        </ButtonMultiClick>
        <ButtonMultiClick fillColor medium onClick={handleStart}>
          最初から再生
        </ButtonMultiClick>
      </div>
    </div>
  );
}
